// Livelli di log canonici del backend e loro normalizzazione. Specchio di
// `LogLevel` (dart) e della normalizzazione in `LogDevice`/`LogEvent` (gem):
// warn→warning, err→error, unknown→fatal, livello ignoto→info.

import type { LogLevel } from './types'

const ORDINALS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warning: 2,
  error: 3,
  fatal: 4,
}

const ALIASES: Record<string, LogLevel> = {
  warn: 'warning',
  err: 'error',
  unknown: 'fatal',
}

/// Normalizza un livello arbitrario al canone wire (`debug|info|warning|error|fatal`).
export function normalizeLogLevel(input: string): LogLevel {
  const value = input.trim().toLowerCase()
  if (value in ORDINALS) return value as LogLevel
  return ALIASES[value] ?? 'info'
}

/// Posizione del livello nella scala di severità (debug=0 … fatal=4).
export function logLevelOrdinal(level: LogLevel): number {
  return ORDINALS[level]
}

/// `true` se [level] è pari o superiore a [min].
export function meetsMinLevel(level: LogLevel, min: LogLevel): boolean {
  return logLevelOrdinal(level) >= logLevelOrdinal(min)
}
